export const quizId = 'einstein';
export const questionId = 1;
export const quizStatements = [
    {
        id:1,
        source:"Condicionamiento clásico, Pavlov.",
        text: "Los perros babean cuando ven comida. Si siempre oyen una campana antes de comer, babearán cuando oigan una campana.",
        cat:"hip"
    },
    {
        id:2,
        source: "Refracción, Newton.",
        text: "La luz blanca contiene todos los colores. Cada color viaja en una longitud de onda diferente. Al pasar por un prisma, cada color irá en un ángulo diferente. ",
        cat:"hip"
      },
      {
        id:3,
        source: "Big Bang, Lemaître.",
        text: "Hace 14 billones de años toda la materia estaba concentrada en un punto, que se expandió repentinamente y sigue expandiéndose hoy.",
        cat:"teo"
      },
      {
        id:4,
        source: "Evolución, Darwin.",
        text: "Toda vida tiene el mismo origen y la diversidad nace cuando los organismos se adaptan a ambientes específicos.  (Teoría)",
        cat:"teo"
      },
      {
        id:5,
        source: "Relatividad, Einstein.",
        text: "La gravedad no es una fuerza. Es la curva que hacen los objetos en el espacio y tiempo.",
        cat:"teo"
      },
      {
        id:6,
        source: "Órbita planetaria, Kepler.",
        text: "Los planetas giran alrededor del sol en órbitas elípticas",
        cat:"ley"
      },
      {
        id:7,
        source: "Gravedad, Newton.",
        text: "Gravedad, Newton. Todos los objetos, no importa su tamaño, atraen a los objetos que los rodean.",
        cat:"ley"
      },
      {
        id:8,
        source: "Movimiento, Newton.",
        text: "Un objeto que está quieto va a quedarse quieto y un objeto que está en movimiento seguirá en movimiento a menos que algo lo detenga.",
        cat:"ley"
      }
  ];